import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";

/**
 * Generated class for the WoundHistoryPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "wound-history-popover",
  templateUrl: "wound-history-popover.html",
})
export class WoundHistoryPopoverComponent {
  keys: string[];

  constructor(public navParams: NavParams, public viewCtrl: ViewController) {
    this.keys = this.navParams.data.keys;
  }

  selectedKey(key: string) {
    this.viewCtrl.dismiss(key);
  }
}



// WEBPACK FOOTER //
// ./src/components/wound-history-popover/wound-history-popover.ts